export default __webpack_public_path__ + "static/media/ADEPT.9410b130.png";